/**
 * Input component with consistent focus/disabled styling
 */

import type { ComponentPropsWithoutRef } from "react";

type InputProps = ComponentPropsWithoutRef<"input">;

export function Input({ className = "", ...rest }: InputProps) {
  return (
    <input
      className={`w-full rounded-md border border-border-primary bg-surface-primary px-3 py-2.5 text-sm text-text-primary focus:border-accent-blue focus:outline-none disabled:cursor-not-allowed disabled:bg-surface-tertiary disabled:text-text-muted ${className}`}
      {...rest}
    />
  );
}
